export const corruptSaveFileCheck = (localFile, saveFile) => {
  const safeJsonParse = (value) => {
    if (value === undefined || value === null) return null;
    const raw = typeof value === "string" ? value : String(value);
    const text = raw.trim();
    if (!text || text === "undefined") return null;
    try {
      return JSON.parse(text);
    } catch {
      return null;
    }
  };

  let getStoreData = safeJsonParse(localFile);
  console.log(getStoreData, "get storedata");

  const getStoreDataLength =
    typeof getStoreData?.score === "string"
      ? getStoreData.score.split(",").length
      : null;
  const saveFileLength =
    saveFile !== null && saveFile !== undefined
      ? (() => {
          const parsed = safeJsonParse(saveFile);
          return typeof parsed?.score === "string"
            ? parsed.score.split(",").length
            : null;
        })()
      : null;

  if (
    getStoreDataLength == saveFileLength ||
    saveFile == null ||
    saveFile == undefined ||
    getStoreData == null
  ) {
    return true;
  } else {
    return false;
  }
};
